import { render, staticRenderFns } from "./VerifactuNotificationModal.vue?vue&type=template&id=3b5c570f&scoped=true&lang=pug&"
import script from "./VerifactuNotificationModal.vue?vue&type=script&lang=js&"
export * from "./VerifactuNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./VerifactuNotificationModal.vue?vue&type=style&index=0&id=3b5c570f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c570f",
  null
  
)

export default component.exports